import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';
import { TabsContent } from '@/components/ui/tabs';

import { TabProps } from '../tabConfig';
import { InsuranceCarriersTable } from './table';

export function InsuranceCarriersTab({
	importTypeId,
	importTypeName,
}: TabProps) {
	return (
		<TabsContent value="insuranceCarriers">
			<Card>
				<CardHeader>
					<CardTitle>Insurance Carriers</CardTitle>
					<CardDescription>
						Insurance Carrier Mappings for {importTypeName} - {importTypeId}
					</CardDescription>
				</CardHeader>
				<CardContent className="space-y-2">
					<InsuranceCarriersTable importTypeId={importTypeId} />
				</CardContent>
			</Card>
		</TabsContent>
	);
}
